module.exports = "<p>{{t('actionWanDnsPlaceholder.defaultDns')|e}}</p>\n<a class=\"btn btn-primary btn-sm\">{{t('actionWanDnsPlaceholder.customDns')|e}}</a>\n";
